import {connect} from "react-redux";
import RegularizationRequestsForManager from "./RegularizationRequestsForManager";
import {bindActionCreators} from "redux";
import { regularizationDetailsForManager, getRegularizationRequestFilter } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    regularizationDetails: state.DarwinAttendanceSync.regularizationDetails,
    regularizationFilter: state.DarwinAttendanceSync.regularizationFilter
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            regularizationDetailsForManager,
            getRegularizationRequestFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RegularizationRequestsForManager);
